import React from "react";
import { Link } from "react-router-dom";
import { profile } from "./content";
import { Arrow } from "./Icons";
import SiteMeta from "./SiteMeta";

export default function Contact() {
  return (
    <>
      <SiteMeta
        title="Contact"
        path="/contact"
        description="Get in touch with Hunter Grey about developer tools, personal software, or self-hosted systems. Email and code profiles."
      />
      <header className="page-intro">
        <h1>
          Let’s talk<span>.</span>
        </h1>
        <p>
          A question about a project, an idea to explore, or just a hello. Email
          is a good place to start.
        </p>
      </header>
      <div className="contact-layout">
        <section className="email-panel" aria-labelledby="email-title">
          <h2 id="email-title">Say hello</h2>
          <a className="email-address" href={`mailto:${profile.email}`}>
            {profile.email}
            <Arrow diagonal />
          </a>
          <p>
            I’m especially interested in developer tools, local-first software,
            and systems you can run yourself.
          </p>
          <a className="button" href={`mailto:${profile.email}`}>
            Write an email <Arrow />
          </a>
        </section>
        <section className="elsewhere" aria-labelledby="elsewhere-title">
          <h2 id="elsewhere-title">Elsewhere</h2>
          {[
            ["GitLab", "My projects and source code", profile.gitlab],
            ["GitHub", "Code and experiments", profile.github],
            ["LinkedIn", "Professional profile", profile.linkedin],
          ].map(([name, description, url]) => (
            <a key={name} href={url} target="_blank" rel="noopener noreferrer">
              <span>
                <strong>{name}</strong>
                <span>{description}</span>
              </span>
              <Arrow diagonal />
            </a>
          ))}
          <Link to="/resume">
            <span>
              <strong>Résumé</strong>
              <span>Background and PDF</span>
            </span>
            <Arrow />
          </Link>
        </section>
      </div>
    </>
  );
}
